import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { Exercise } from 'modules/exercises/types';

import {
  getAssignmentExercisesQuery,
  GetAssignmentExercisesQueryResult,
  GetAssignmentExercisesQueryVariables,
} from '../graphql/queries/getAssignmentExercisesQuery';

type AssignmentExercisesHookResult = DataFetcherHookResult<Exercise[], 'exercises'>;

interface AssignmentExercisesHookInput {
  courseId: string;
  assignmentId: string;
}

export default function useAssignmentExercises(input: AssignmentExercisesHookInput): AssignmentExercisesHookResult {
  const { courseId, assignmentId } = input;
  const { data, loading, error } = useQuery<GetAssignmentExercisesQueryResult, GetAssignmentExercisesQueryVariables>(getAssignmentExercisesQuery, {
    variables: { courseId, assignmentId },
  });

  return { loading, error: getErrorMessage({ error }), exercises: data?.exercises };
}
